import React from "react";

import logIn from "@iconify/icons-lucide/log-in";
import { Icon } from "@iconify/react/dist/offline";
import { useSnackbar } from "notistack";

import backendClient from "src/api";
import type { OIDCProviderOption } from "src/client";
import { Button } from "src/components/ui/button";

interface OIDCLoginButtonProps {
  provider: OIDCProviderOption;
}

export const OIDCLoginButton: React.FC<OIDCLoginButtonProps> = ({
  provider,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const handleOIDCLogin = async () => {
    try {
      // Get the authorization URL from the backend
      const response = await backendClient.auth.initiateOidcLogin(
        provider.providerId
      );

      if (response.url) {
        // Redirect to the OIDC provider's login page
        window.location.href = response.url;
      } else {
        console.error("No authorization URL received");
        enqueueSnackbar("Failed to initiate login", { variant: "error" });
      }
    } catch (error) {
      console.error("Failed to initiate OIDC login:", error);
      enqueueSnackbar("Failed to initiate login. Please try again.", {
        variant: "error",
      });
    }
  };

  return (
    <Button variant="outline" className="w-full" onClick={handleOIDCLogin}>
      <Icon icon={logIn} width={16} height={16} className="mr-2" />
      Sign in with {provider.displayName}
    </Button>
  );
};
